import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http'
import * as globalConst from './../../../constants';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class CommercialCompetenceService {
	private apiUrl = globalConst.baseAPI;  // URL para web api

	public proposalID = "";
	public proposalCultures = [];

	constructor(private http: Http) { }

	getProposalLog(proposalID) {
		return this.http
			.get(this.apiUrl + "logs/v1/logsproposal/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAlcadaMaxProposalValue() {
		return this.http
			.get(this.apiUrl + "system/v1/getcodparameterstype/alcada", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCtcByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getctcbyaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	sendProposalToCtc(obj) {
		return this.http
			.post(this.apiUrl + "tradearea/v1/sendctc/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}	
	

	sendProposalToCredit(obj) {
		return this.http
			.post(this.apiUrl + "tradearea/v1/sendanalysis/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}	

	getProposalData(proposalID) {
		return this.http
			.get(this.apiUrl + "tradearea/v1/get/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveProposalData(proposalData) {
		return this.http
			.post(this.apiUrl + "tradearea/v1/save/", proposalData, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	cancelProposal(proposalID) {
		return this.http
			.delete(this.apiUrl + "tradearea/v1/cancel/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	denyProposal(proposalID) {
		return this.http
			.delete(this.apiUrl + "tradearea/v1/disapprove/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getClientTypeByID(tipoClienteID) {
		return this.http
			.get(this.apiUrl + "clienttypes/v1/getcodclienttype/" + tipoClienteID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getClientTypes() {
		return this.http
			.get(this.apiUrl + "clienttypes/v1/getclienttypes?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getExperienceTypes() {
		return this.http
			.get(this.apiUrl + "/experiences/v1/getexperience?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getStates() {
		return this.http
			.get(this.apiUrl + "/state/v1/getstates?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCitiesByState(cityID) {
		return this.http
			.get(this.apiUrl + "/city/v1/getcitybystate/" + cityID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCultureList() {
		return this.http
			.get(this.apiUrl + "/culture/v1/getculture?$filter=Ativo eq true&$orderby=Descricao", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getProductsList() {
		return this.http
			.get(this.apiUrl + "/product/v1/getservices?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}
	
	
	editProposal(proposalID){

		const tempObj = {
			ID: proposalID
		}

		return this.http
		.post(this.apiUrl + "tradearea/v1/edit", tempObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});		
	}

	checkSerasa(proposalID) {
		return this.http
			.get(this.apiUrl + "serasa/v1/tradearea/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	approveProposal(proposalID, AccountClientID){
		const tempObj = {
			ID: proposalID,
			ContaClienteID:AccountClientID
		}

		return this.http
		.post(this.apiUrl + "tradearea/v1/aproveproposal/",tempObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json());
	}

	aproveByCTC(proposalID, AccountClientID){
		const tempObj = {
			ID: proposalID,
			ContaClienteID:AccountClientID
		}

		return this.http
		.post(this.apiUrl + "tradearea/v1/aprovectc/",tempObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json());
	}
	
	searchNameByDoc(document) {
		var obj = {
			Documento: document
		}

		return this.http
			.post(this.apiUrl + "accounts/v1/searchcustomer/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//GET 

	/////////////////////////////////////////////////////////////////Demo Methods 

	saveClientGuarantee(obj) {
		return this.http
			.post(this.apiUrl + "guarantee/v1/insertlistguarantee", [obj], JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateClientGuarantee(obj) {
		return this.http
			.put(this.apiUrl + "guarantee/v1/updatelistguarantee", [obj], JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getGuarantees(id) {
		return this.http
			.get(this.apiUrl + "guarantee/v1/getguarantee/" + id + "/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/commercial-competence/services/commercial-competence.service.ts